const TimeRecordingType = props => {
    return (
        <div className="mfx-detailview-formelements-full-width" style={{ paddingBottom: '20px', marginBottom: '10px', borderBottom: '1px solid var(--fontColor)' }}>
            {
                //<label htmlFor={props.designData?.Key + '-div'}>{window.Dictionary.getTranslation(props.designData?.Label)}:</label>
            }
            <div id={props.designData?.Key + '-div'} className="mfx-detailview-formelements-nested">
                {props.designData?.Options?.map(type => {
                    return (
                        <div>
                            <button
                                style={{border: type.Value === props.customData ? '1px solid blue':'', width: '120px'}}
                                className="icon-button time-recording-type"
                                onClick={e => {
                                    e.preventDefault();
                                    if (props.disableMode) return;
                                    props.onChangeHandler({ newValue: type.Value, designData: props.designData });
                                }}>
                                <i className={type.Icon} />
                                <span>{type.Label}</span>
                            </button>
                        </div>
                    );
                })}
                {!props.designData?.Options && <h1>Typesettings in Designer missing</h1>}
            </div>
        </div>
    );
};

export default TimeRecordingType;
